import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SortOrder } from "primereact/api";

interface UsersListFilterState {
	searchFilter: string;
	districtFilter: number;
	schoolFilter: number;
	roleFilter: string;
	includeInactive: boolean;
	sortField: string;
	sortOrder: SortOrder;
	page: number;
}

const initialState: UsersListFilterState = {
	searchFilter: "",
	districtFilter: 0,
	schoolFilter: 0,
	roleFilter: "",
	includeInactive: false,
	sortField: "userName",
	sortOrder: 1,
	page: 0,
};

const usersListFilterSlice = createSlice({
	name: "usersListFilter",
	initialState,
	reducers: {
		setSearchFilter: (state, action: PayloadAction<string>) => {
			state.searchFilter = action.payload;
		},
		setDistrictFilter: (state, action: PayloadAction<number>) => {
			state.districtFilter = action.payload;
		},
		setSchoolFilter: (state, action: PayloadAction<number>) => {
			state.schoolFilter = action.payload;
		},
		setRoleFilter: (state, action: PayloadAction<string>) => {
			state.roleFilter = action.payload;
		},
		setIncludeInactive: (state, action: PayloadAction<boolean>) => {
			state.includeInactive = action.payload;
		},
		setSortField: (state, action: PayloadAction<string>) => {
			state.sortField = action.payload;
		},
		setSortOrder: (state, action: PayloadAction<SortOrder>) => {
			state.sortOrder = action.payload;
		},
		setPage: (state, action: PayloadAction<number>) => {
			state.page = action.payload;
		},
		resetUsersListFilters: () => initialState,
	},
});

export const {
	setSearchFilter,
	setDistrictFilter,
	setSchoolFilter,
	setRoleFilter,
	setIncludeInactive,
	setSortField,
	setSortOrder,
	setPage,
	resetUsersListFilters,
} = usersListFilterSlice.actions;

export default usersListFilterSlice.reducer;
